<template>
    <div id="add-organization-dialog">
        <el-dialog :title="title" :visible.sync="dialogVisible" :close-on-click-modal="false" @close="cancelDialog" class="dialog-medium">
            <el-form  style="width: auto" ref="orgForm" :rules="orgFormRules" :model="orgForm" label-width="115px" label-position="left">
                <el-form-item  label="组织名称" prop="name" class="is-required">
                    <el-input clearable placeholder="请输入组织名称" v-model="orgForm.name" type="text" maxlength="30" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="上级组织" prop="parentName" class="is-required" v-if="orgType === 3">
                    <el-input clearable placeholder="请选择上级组织" v-model="orgForm.parentName" type="text" disabled>
                        <el-button slot="append" type="primary" plain @click="organizationDialog=true">选择上级</el-button>
                    </el-input>
                </el-form-item>
                <el-form-item label="级别" prop="levelId" class="is-required" v-show="orgType===3">
                    <el-select v-model="orgForm.levelId" disabled>
                        <el-option v-for="item in levelList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="组织类别" prop="categoryId" class="is-required" v-show="orgType===3">
                    <el-select v-model="orgForm.categoryId">
                        <el-option v-for="item in categoryList" :key="item.categoryId" :label="item.cateName" :value="item.categoryId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="orgType==2" label="工厂类别" prop="factoryType" class="is-required">
                    <el-radio-group v-model="orgForm.factoryType">
                        <el-radio :label="0">自有工厂</el-radio>
                        <el-radio :label="1">代工厂</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item  label="组织编码" prop="code">
                    <el-input clearable placeholder="请输入组织编码" v-model="orgForm.code" type="text" maxlength="32" show-word-limit></el-input>
                </el-form-item>
                <el-form-item  label="组织状态" prop="status">
                    <el-switch v-model="orgForm.status" :active-value="1" :inactive-value="0"></el-switch>
                </el-form-item>
                <el-form-item prop="master" label="负责人" v-if="isEditOrAdd">
                    <el-input clearable placeholder="请选择负责人" v-model="orgForm.master" type="text" maxlength="30">
                        <el-button slot="append" type="primary" plain @click="manInChargeDialog=true">选择负责人</el-button>
                    </el-input>
                </el-form-item>
                <el-form-item label="组织邮箱" prop="email">
                    <el-input placeholder="请输入组织邮箱" v-model="orgForm.email" type="email" maxlength="32" ></el-input>
                </el-form-item>
                 <el-form-item label="选择地区" >
                     <template slot-scope="scope">
                          <el-cascader v-model="region"  :options="areaList" :props="cityprops"  clearable ></el-cascader>
                     </template>
                </el-form-item>
                <el-form-item prop="detail" label="详细地址">
                    <el-input clearable placeholder="请输入详细地址，具体到门牌号" v-model="orgForm.detailAddress" type="textarea" :autosize="{ minRows: 2, maxRows: 4}"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelDialog">取消</el-button>
                <el-button type="primary" plain @click="saveOrganization('orgForm')" v-duplication>保存</el-button>
            </div>
        </el-dialog>
        <man-in-charge :visible.sync="manInChargeDialog" :org-id="organizationDetail.id" :tenant-id="tenantId" @close="manInChargeDialog=false" @confirm="confirmMaster"></man-in-charge>
        <parent-organization :visible.sync="organizationDialog" @close="organizationDialog=false" @confirm="confirmParentOranization" :updateLevelList="[organizationDetail.id]"></parent-organization>
    </div>
</template>
<script>
import manInCharge from './manInCharge';
import parentOrganization from './parentOrganization';
import { mapActions } from 'vuex';
export default {
    props: ['visible', 'orgId', 'isEditOrAdd', 'tenantId', 'orgType', 'selectedOrg'], // 组织类型 0-企业，1-供应商，2-工厂，3-经销商，4-仓库，5-产线
    components: {
        'manInCharge': manInCharge,
        'parentOrganization': parentOrganization
    },
    data() {
        let _self = this;
        let name = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(_self.$STR('org.baseInfoForm.data.name', '组织名称不能为空')));
                return;
            } else {
                callback();
            }
        };
        let master = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(_slef.$STR('org.baseInfoForm.data.master', '负责人不能为空')));
                return;
            } else {
                callback();
            }
        };
        let address = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(_self.$STR('org.baseInfoForm.data.address', '地址不能为空')));
                return;
            } else {
                callback();
            }
        };
        return {
            dialogVisible: false,
            title: _self.$STR('org.baseInfoForm.data.newOrg', '新增企业'),
            orgForm: {
                id: '',
                name: '',
                code: '',
                tenantId: '',
                master: '',
                email: '',
                detailAddress: '',
                contact: '', // 联系人
                parentId: '', // 上级组织id
                parentName: '', //上级组织名称
                orgType: '', // 组织类型 0-企业，1-供应商，2-工厂，3-经销商，4-仓库，5-产线
                factoryType: 0, // 工厂类型 0-自工厂 1-代工厂
                lat: '',
                lon: '',
                levelId: '',
                categoryId: '',
                status: 1,
                province: '',
                area: '',
                city: ''
            },
            orgFormRules: {
                name: [{validator: name, trigger: 'blur'}],
                parentId: [{required: true, message: '上级组织不能为空', trigger: 'blur'}],
                levelId: [{required: true, message: '级别不能为空', trigger: 'blur'}],
                categoryId: [{required: true, message: '组织类别不能为空', trigger: 'blur'}],
                email: [{validator: $Validate.emailNotMust, trigger: 'blur'}]
            },
            manInChargeDialog: false, // 选择负责人弹框
            organizationDialog: false, // 选择上级弹框
            levelList: [], // 级别列表
            categoryList: [], // 类别列表
            orgTypeOptions: [], // 组织类型列表
            organizationDetail: {}, // 组织详情（如果是编辑状态为被编辑的组织信息，如果是新增状态则为上级组织信息）
            areaList: [],
            cityprops: {
                label: 'name',
                value: 'code',
                checkStrictly: true
            },
            region: []
        };
    },
    watch: {
        visible(newValue, OldValue) {
            this.dialogVisible = this.visible;
            if (!newValue) {
                this.msgInstance && this.msgInstance.close();
                return;
            };
            this.getOrgDetail();
        }
    },
    mounted() {
    },
    created() {
        this.getLevelList();
        this.getOrgTypeList();
        this.getAreaTree();
    },
    methods: {
        ...mapActions(['getAreaTreeAction']),
        //获取组织类型列表
        getOrgTypeList() {
            var temp = function(val, target) {
                var list = val;
                target.orgTypeOptions = list;
            };
            commonRequest.getDataDictionary('org_allorg_type', this, temp);
        },
        // 查询组织机构详情
        getOrgDetail () {
            this.$http.get(Assist.PathParams(WebApi.organization.selectById, { id: this.orgId })).then((res) => {
                if (res.data.success) {
                    this.organizationDetail = res.data.data;
                    if (this.isEditOrAdd) {
                        for (let item in this.organizationDetail) {
                            if (this.organizationDetail[item] === null) {
                                this.orgForm[item] = '';
                                continue;
                            }
                            this.orgForm[item] = this.organizationDetail[item];
                        }
                        this.title = `编辑${this.getOrgTypeName(this.orgType)}`;
                        this.getCategoryList();
                        this.getAreaTree();
                    } else {
                        for (let item in this.orgForm) if (typeof this.orgForm[item] === 'string') this.orgForm[item] = '';
                        this.title = `新增${this.getOrgTypeName(this.orgType)}`;
                        this.orgForm.levelId = parseInt(this.organizationDetail.levelId) + 1 + '';
                        this.orgForm.parentId = this.organizationDetail.id;
                        this.orgForm.parentName = this.organizationDetail.name;
                        this.getCategoryList().then(res => { this.orgForm.categoryId = this.categoryList[0] ? this.categoryList[0].categoryId : ''; } );
                    }
                    // if (this.orgForm.province) this.getAreaList(this.orgForm.province, 'cityOptions', false);
                    // if (this.orgForm.city) this.getAreaList(this.orgForm.city, 'areaOptions', false);
                    this.orgForm.province && this.$set(this.region, 0, this.orgForm.province);
                    this.orgForm.city && this.$set(this.region, 1, this.orgForm.city);
                    this.orgForm.area && this.$set(this.region, 2, this.orgForm.area);
                    // console.log(this.region);
                    // this.$forceUpdate();
                } else {
                    this.$message({ showClose: true, message: this.$STR(res.data.resultCode, res.data.message), type: 'error' });
                }
            });
        },
        // 翻译组织机构名称
        getOrgTypeName (orgType) {
            let name = '';
            this.orgTypeOptions.forEach(item => { if (parseInt(item.value) === parseInt(orgType)) name = item.label; });
            return name || '经销商';
        },
        // 获取级别列表
        getLevelList () {
            this.$http.get(WebApi.organization.levelList, {}).then(res => {
                this.levelList = res.data;
            });
        },
        // 获取组织类别列表
        getCategoryList () {
            return this.$http.get(WebApi.organization.categoryList, { params: { id: this.orgForm.levelId } }).then(res => {
                this.categoryList = res.data[0] ? res.data[0].categoriesNameList : [];
                if (this.orgType === 3 && (!this.categoryList || !this.categoryList.length)) {
                    this.msgInstance = this.$message({
                        message: '请到组织设置中添加组织类别',
                        type: 'warning',
                        duration: 0
                    });
                }
                return;
            });
        },
        //选择上级
        confirmParentOranization(val) {
            if (val) {
                this.orgForm.parentId = val.id;
                this.orgForm.parentName = val.name;
                this.orgForm.levelId = parseInt(val.levelId) + 1 + '';
                this.orgForm.categoryId = '';
                this.getCategoryList().then(res => { this.orgForm.categoryId = this.categoryList[0] ? this.categoryList[0].categoryId : ''; } );
            }
        },
        // 选择负责人
        confirmMaster (val) {
            if (val) {
                this.orgForm.master = val.userName ? val.userName : '';
            }
        },
        cancelDialog() {
            this.region = [];
            this.$refs['orgForm'].resetFields();
            this.dialogVisible = false;
            this.$emit('close');
        },
        saveOrganization(orgForm) {
            let method = this.isEditOrAdd ? 'put' : 'post';
            let url = this.isEditOrAdd ? WebApi.organization.updateOrg : WebApi.organization.addOrg;
            let formData = new FormData();
            formData.append('id', this.orgForm.id);
            formData.append('tenantId', this.tenantId);
            formData.append('orgType', this.orgType);
            formData.append('factoryType', this.orgForm.factoryType);
            formData.append('name', this.orgForm.name);
            formData.append('email', this.orgForm.email);
            formData.append('detailAddress', this.orgForm.detailAddress);
            formData.append('master', this.orgForm.master ? this.orgForm.master : '');
            formData.append('parentId', this.orgForm.parentId);
            formData.append('levelId', this.orgForm.levelId);
            formData.append('categoryId', this.orgForm.categoryId);
            formData.append('status', this.orgForm.status);
            formData.append('provinceCode', +this.region[0] || '');
            formData.append('cityCode', +this.region[1] || '');
            formData.append('areaCode', +this.region[2] || '');
            var reg = /[`~!#%^&*=+\\|{};:'\",<>/?○●★☆☉♀♂※¤╬の〆]/g;
            if (reg.test(this.orgForm.code)) {
                this.$message({
                    showClose: true,
                    message: this.$STR('Operation:orgCodeString:message', '组织编码格式错误!'),
                    type: 'error'
                });
                return;
            };
            formData.append('code', this.orgForm.code);
            // 设置经纬度开始
            let setLocation = (id, whichOption) => {
                this[whichOption].forEach(item => {
                    if (item.id === id) {
                        this.orgForm.lat = item.latitude;
                        this.orgForm.lon = item.longitude;
                    }
                });
                formData.append('lat', this.orgForm.lat);
                formData.append('lon', this.orgForm.lon);
            };
            // 设置经纬度结束
            this.$refs[orgForm].validate((valid) => {
                if (valid) {
                    this.$http({
                        url: url,
                        method: method,
                        data: formData,
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then(response => {
                        if (response.data.success) {
                            this.dialogVisible = false;
                            this.$emit('close');
                            this.$refs['orgForm'].resetFields();
                            // 将新增 / 编辑的最新数据回传
                            const rowData = response.data.data;
                            rowData && (rowData.formerParentId = this.selectedOrg.parentId);
                            this.$emit('update', this.orgForm.parentId, rowData);
                            $ActionAlert(response, this);
                        } else {
                            this.$message({
                                showClose: true,
                                message: this.$STR(response.data.resultCode, response.data.message),
                                type: 'error'
                            });
                        }
                    });
                } else {
                    return false;
                }
            });
            this.region = [];
        },
        OnChange(file, fileList) {
            this.orgForm.logos = fileList;
        },
        OnRemove(file, fileList) {
            this.orgForm.logos = fileList;
        },
        OnChangelicenses(file, fileList) {
            this.orgForm.licenses = fileList;
        },
        OnRemovelicenses(file, fileList) {
            this.orgForm.licenses = fileList;
        },
        OnChangeothers(file, fileList) {
            this.orgForm.others = fileList;
        },
        OnRemoveothers(file, fileList) {
            this.orgForm.others = fileList;
        },
        async getAreaTree() {
            this.areaList = await this.getAreaTreeAction(this.$http);
        },
    }
};
</script>
<style>
    #add-organization-dialog .el-form-item__error{
        padding-top: 2px;
    }
    #add-organization-dialog .address-form {
        display: flex;
        width: 280px;
    }
    #add-organization-dialog .address-form .el-select {
        width: 100px;
        margin: 0 0 10px 0;
    }
    #add-organization-dialog .address-form .el-select .el-input {
        width: 100%;
    }
    #add-organization-dialog .address-form .el-select+.el-select {
        margin: 0 0 0 5px;
    }
    #add-organization-dialog .address-form .el-input {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/views/cloud/organization/basicInfoForm.vue